<template>
  <Select
    :items="grupos"
    :selectedItem="filter.grupo"
    :label="filtro.name"
    searchPlaceholder="Buscar grupo"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';

export default {
  components: {
    Select
  },
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      filter: {
        grupo: {
          id: '',
          name: ''
        }
      },
      grupos: []
    };
  },
  methods: {
    atualizar(grupo) {
      this.filter.grupo = grupo;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.grupo.id, this.path);
      if (!this.$store.state.filtros.some(f => f.filtro === this.filtro.filtro)) {
        this.$store.commit('addFiltro', this.filtro);
      }
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.grupo.id
      });
    },
    processarGrupos(grupos) {
      this.grupos = grupos.map((grupo) => ({
        id: String(grupo.id),
        name: grupo.name
      }));
      const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
      this.$renderFiltroSelect(filtroAplicado, this.grupos, this.filter.grupo);
    }
  },
  mounted() {
    const { parametros } = this.filtro;

    if (parametros && Array.isArray(parametros.grupos)) {
      this.processarGrupos(parametros.grupos);
      return;
    }

    this.$api.get('/admin/grupos.json').then((response) => {
      this.processarGrupos(response.data);
    }).catch((error) => {
      console.error('Erro ao buscar grupos:', error);
    });
  }
}
</script>
